export const SET_CRUISE_LISTING = 'SET_CRUISE_LISTING'
export const SET_CRUISE_ITINERARY = 'SET_CRUISE_ITINERARY'
export const ROOM_ALTERNATES = 'CRUISE_ROOM_ALTERNATES'
export const SET_ROOM_ALTERNATES = 'SET_CRUISE_ROOM_ALTERNATES'
export const RAW_ROOM_ALTERNATES = 'RAW_CRUISE_ROOM_ALTERNATES'
export const SET_RAW_ROOM_ALTERNATES = 'SET_CRUISE_RAW_ROOM_ALTERNATES'
export const SET_SEARCH_QUERY = 'SET_CRUISE_SEARCH_QUERY'

export const SET_CRUISE_PORT_LISTING = 'SET_CRUISE_PORT_LISTING'
export const SET_ALL_ROOM_TYPES = 'SET_ALL_ROOM_TYPES'
export const SET_CRUISE_ITINERARY_POLICIES = 'SET_CRUISE_ITINERARY_POLICIES'
